<template>
  <b-modal id="org-sso" centered hide-header hide-footer>
    <h3>Single Sign-On (SSO)</h3>
    <p>
      Secure Single Sign-On (SSO) capability that allows users to log into
      Nanome using IDP credentials by SAML Authentication
    </p>

    <b-checkbox v-model="enableSaml" class="my-2" switch>
      Enable SAML SSO
    </b-checkbox>

    <div :style="{ opacity: enableSaml ? 1 : 0.5 }">
      <h5 class="mt-4 mb-1">IdP metadata URL</h5>
      <b-input v-model="samlMetadataURL" :disabled="!enableSaml" />

      <h5 class="mt-4 mb-1">
        Single sign-on URL
        <b-btn
          v-b-tooltip.hover="'copy'"
          class="mb-auto"
          size="sm"
          variant="white"
          @click="$copy(urlACS)"
        >
          <i class="icon-docs" />
        </b-btn>
      </h5>
      <b-input :value="urlACS" readonly />

      <h5 class="mt-4 mb-1">
        Audience URI (SP Entity ID)
        <b-btn
          v-b-tooltip.hover="'copy'"
          class="mb-auto"
          size="sm"
          variant="white"
          @click="$copy(urlSP)"
        >
          <i class="icon-docs" />
        </b-btn>
      </h5>
      <b-input :value="urlSP" readonly />

      <p class="mt-4 small">
        Note: make sure the nameID or Unique User Identifier is set to email
        address
      </p>
    </div>

    <div class="mt-4 text-right">
      <b-btn
        class="ml-2 px-4"
        variant="secondary"
        @click="$bvModal.hide('org-sso')"
      >
        Cancel
      </b-btn>
      <b-btn
        :disabled="$v.$invalid || !hasChanges"
        class="ml-2 px-4"
        variant="primary"
        type="submit"
        @click="enableSaml ? enableSamlSSO() : disableSamlSSO()"
      >
        Save
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, url } from "vuelidate/lib/validators";
import API from "@/api";

const API_URL = process.env.VUE_APP_API;

export default {
  mixins: [validationMixin],

  props: {
    org: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    enableSaml: false,
    samlMetadataURL: ""
  }),

  computed: {
    hasChanges() {
      const hasChanges =
        this.enableSaml !== this.org.settings.sso_saml ||
        this.samlMetadataURL !== this.org.settings.sso_saml_metadata_url;
      return hasChanges;
    },

    urlACS() {
      return `${API_URL}/sso/saml/${this.org.id}/acs`;
    },

    urlSP() {
      return `${API_URL}/sso/saml/${this.org.id}/sp`;
    }
  },

  watch: {
    org: {
      handler() {
        this.enableSaml = !!this.org.settings.sso_saml;
        this.samlMetadataURL = this.org.settings.sso_saml_metadata_url;
      },
      immediate: true
    }
  },

  methods: {
    async disableSamlSSO() {
      const { success } = await API.disableOrgSamlSSO(this.org.id);
      if (!success) return;

      this.$emit("updated");
      this.$notify({
        type: "success",
        text: "SAML SSO disabled"
      });
      this.$bvModal.hide("org-sso");
    },

    async enableSamlSSO() {
      const { success } = await API.enableOrgSamlSSO(
        this.org.id,
        this.samlMetadataURL
      );
      if (!success) return;

      this.$emit("updated");
      this.$notify({
        type: "success",
        text: "SAML SSO enabled"
      });
      this.$bvModal.hide("org-sso");
    }
  },

  validations: {
    samlMetadataURL: { required, url }
  }
};
</script>
